import { MakeCall } from './createMakeCall';

/** @swagger /#api-Default-userUserIdPayoutMethodPost */
export default (makeCall: MakeCall) => (data: {
  accountNumber: string;
  beneficiaryName: string;
  code: string;
  country: string;
  currency: string;
  homeAddress: string;
  iban: string;
  ownerName: string;
  paypalEmail: string;
  customerUUID: string;
  type: 'iban' | 'paypal' | 'bank';
}) =>
  makeCall('POST', `/api/v2/user/me/payout-method`, {
    data,
  });
